import React, { useState, useRef, useEffect } from 'react';
import { useNotifications } from '../../contexts/NotificationContext';
import './NotificationBell.css';

const ICONS = { irrigation: '💧', message: '💬', alert: '⚠️', info: 'ℹ️' };

function timeAgo(date) {
  const s = Math.floor((Date.now() - new Date(date)) / 1000);
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}d`;
  if (s < 86400) return `${Math.floor(s / 3600)}sa`;
  return `${Math.floor(s / 86400)}g`;
}

export default function NotificationBell({ language }) {
  const { notifications, clearAll, dismiss } = useNotifications();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const unread = notifications.length;

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="notif-bell-container" ref={ref}>
      <button className="notif-bell-btn" onClick={() => setOpen(v => !v)} title={language === 'en' ? 'Notifications' : 'Bildirimler'}>
        🌐
        {unread > 0 && <span className="notif-bell-badge">{unread > 99 ? '99+' : unread}</span>}
      </button>

      {open && (
        <div className="notif-dropdown">
          <div className="notif-header">
            <span className="notif-title">{language === 'en' ? 'Notifications' : 'Bildirimler'}</span>
            {unread > 0 && (
              <button className="notif-clear-btn" onClick={clearAll}>
                {language === 'en' ? 'Clear all' : 'Temizle'}
              </button>
            )}
          </div>

          <div className="notif-list">
            {notifications.length === 0 ? (
              <div className="notif-empty">
                <span>🔕</span>
                <p>{language === 'en' ? 'No notifications' : 'Bildirim yok'}</p>
              </div>
            ) : (
              notifications.map(n => (
                <div key={n.id} className={`notif-item notif-${n.type || 'info'}`}>
                  <span className="notif-item-icon">{ICONS[n.type] || ICONS.info}</span>
                  <div className="notif-item-body">
                    <span className="notif-item-text">{n.text}</span>
                    <span className="notif-item-time">{timeAgo(n.time)}</span>
                  </div>
                  <button className="notif-item-dismiss" onClick={() => dismiss(n.id)}>✕</button>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
